export default __webpack_public_path__ + "static/hw_ff_buzzer-710f5eff6e747199cf593dc8a8b35b2d.png";